import { Suspense, ComponentType } from 'react';
import { Card } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import ErrorBoundary from '@/components/ErrorBoundary';

const RouteLoadingFallback = ({ routeName }: { routeName?: string }) => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <Card className="p-6 text-center">
      <Loader2 className="h-6 w-6 animate-spin mx-auto mb-3" />
      <p className="text-sm text-muted-foreground" role="status" aria-live="polite">
        {routeName ? `Ladataan: ${routeName}…` : 'Ladataan sivua…'}
      </p>
    </Card>
  </div>
);

interface LazyRouteProps {
  component: ComponentType<any>;
  routeName?: string;
  [key: string]: any;
}

export const LazyRoute = ({ component: Component, routeName, ...props }: LazyRouteProps) => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<RouteLoadingFallback routeName={routeName} />}>
        <Component {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};